export default __webpack_public_path__ + "static/media/InfoBorder.7c665426.svg";